<template>
  <div class="space-between-y">
    <el-dialog :visible.sync="group.dialog" width="500px" title="标签组更新">
      <miu-tag-group @saved="tagGroupSaved" :id="group.id" v-if="group.dialog"></miu-tag-group>
    </el-dialog>

    <div>
      <el-button type="primary" @click="saveGroup(null)">新增组</el-button>
    </div>

    <el-card v-for="(item,index) in list" :key="index" class="card-item">
      <div slot="header" class="top">

        <div class="space-between-x container-left">
          <div>{{ item.name }}</div>
          <el-tag type="info" size="mini">{{ '使用场景：' + (item.useFor === 'product' ? '教师服务' : '家长需求') }}</el-tag>
          <el-tag type="primary" v-if="item.required" size="mini">必选</el-tag>
          <el-tag type="primary" v-if="item.multiple" size="mini">多选</el-tag>
        </div>

        <div>
          <el-button type="text" @click="insertTag(item.id)">新增标签</el-button>
          <el-button type="text" @click="saveGroup(item.id)">编辑</el-button>
        </div>
      </div>

      <el-tag
          v-for="tag in item.tags"
          :key="tag.name"
          closable
          @close="handleDel(tag.id)"
          :type="tag.type"
          class="tag-item"
      >
        {{ tag.name }}
      </el-tag>

      <div class="info-text" v-if="item.tags?.length === 0">无标签</div>

    </el-card>

  </div>
</template>

<script>
import MiuTagGroup from "@/components/MiuTagGroup.vue";
import {miuTag} from "@/api/miu/tag";
import {msg} from "@/assets/js/my-vue-element-ui-js";

export default {
  name: 'MiuTeacherServiceTagManage',
  components: {MiuTagGroup},

  data() {
    return {
      group: {
        dialog: false,
        id: null,
      },
      list: [],
    }
  },

  created() {
    this.getData();

  },

  methods: {
    handleDel(id) {

      this.$confirm("确定删除该标签吗？").then(() => {
        miuTag.deleteTag(id).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.getData();
          }
        })
      })

    },

    saveGroup(id) {
      this.group.id = id;
      this.group.dialog = true;
    },
    tagGroupSaved() {
      this.getData();
      this.group.dialog = false;
      this.group.id = null;
    },


    getData() {
      miuTag.list().then(res => {
        this.list = res.data;
      })
    },

    insertTag(groupId) {
      this.$prompt("请输入标签名", "标签名", {}).then(({value}) => {

        miuTag.insertTag(groupId, value).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.getData();
          }
        })

      })
    },

  },


};
</script>

<style scoped>

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-item {
  margin-bottom: 12px;
}

.tag-item {
  margin-right: 8px;
}
</style>
